import { GpsLocationHistoryService } from "../../services/GpsLocationHistoryService";
import { FileDataService } from "../../services/FileDataService";
import { MapAreaService } from "../../services/MapAreaService";
import { GpsLocationHistory } from "../../entities/GpsLocationHistory";
import { MapArea } from "../../entities/MapArea";

export class ShowTrackModel {
    $q:ng.IQService;
    entityId:number;
    allGpsLocationHistories:GpsLocationHistory[] = [];
    numPoints:number = 0;
    mapAreas:MapArea[];
    selectedMapArea:MapArea;
    imageData:string;
    firstDisplayedPoint:number = 0;
    itemTimeSeen:string = "";
    nDisplayedPoints:number = 10;
    nDisplayedPointsOptions:number [] = [3, 10, 30, 100, 300];
    static $inject = ['$q', 'MapAreaService', 'GpsLocationHistoryService', 'FileDataService'];

    constructor($q:ng.IQService,
                public mapAreaService:MapAreaService,
                public gpsLocationHistoryService:GpsLocationHistoryService,
                public fileDataService:FileDataService){
        this.$q = $q;
    }
    init(entityId:number):ng.IPromise<boolean>{
        if (entityId == null) {
            return this.$q.when<boolean>(true);
        }
        this.entityId = entityId;
        return this.$q.all([
            this.mapAreaService.getAll(),
            this.gpsLocationHistoryService.getByAsset(entityId)]
        ).then((data)=>{
            this.mapAreas = data[0];
            this.allGpsLocationHistories = data[1];
            if (this.allGpsLocationHistories.length > 0) {
                this.itemTimeSeen = this.allGpsLocationHistories[0].timeSeen;
            }
            this.numPoints = this.allGpsLocationHistories.length;
            return this.$q.when<boolean>(true);
        });
    }
    // Given a selection for first point - select the appropriate map
    selectMapArea():boolean{
        var oldMapArea:MapArea = this.selectedMapArea;
        // Use first displayed point to select map
        var point_lat:number = this.allGpsLocationHistories[this.firstDisplayedPoint].latitude;
        var point_long:number = this.allGpsLocationHistories[this.firstDisplayedPoint].longitude;
        var bFound:boolean = false;
        var min_distance:number = 0;
        var bestMap:MapArea = null;
        for (var i = 0; i < this.mapAreas.length; i++) {
            if (!this.hasGpsCoordinates(this.mapAreas[i])) {
                continue;
            }
            var d:number = this.calc_distance(this.mapAreas[i], point_lat, point_long);
            if ((!bFound) || d < min_distance) {
                bFound = true;
                min_distance = d;
                bestMap = this.mapAreas[i];
            }
        }
        this.selectedMapArea = (bFound) ? bestMap : null;
        var bUpdated:boolean = (this.selectedMapArea != oldMapArea);
        return bUpdated;
    }
    // Does the map have GPS coordinates
    hasGpsCoordinates(mapArea:MapArea):boolean {
        if (mapArea.geo1Latitude != null &&
            mapArea.geo1Longitude != null &&
            mapArea.geo2Latitude != null &&
            mapArea.geo2Longitude != null) {
            return true;
        }
        return false;
    }
    // Distance from a point to the center of the map
    calc_distance(mapArea:MapArea, point_lat:number, point_long:number):number {
        // Distance in meters - missing a scale factor of 2 * PI * R / 360.0
        var middle_lat:number = (mapArea.geo1Latitude + mapArea.geo2Latitude) / 2.0;
        var middle_long:number = (mapArea.geo1Longitude + mapArea.geo2Longitude) / 2.0;
        var middle_lat_radians = middle_lat * Math.PI / 180.0;
        var dy:number = point_lat - middle_lat;
        var dx:number = (point_long - middle_long) * Math.cos(middle_lat_radians);
        return Math.sqrt(dx * dx + dy * dy);
    }
    // Retrieve binary data for the map
    getMapAreaImage():ng.IPromise<boolean>{
        return this.fileDataService.get(this.selectedMapArea.fileDataID).then((b64Data:string)=>{
            this.imageData = b64Data;
            return this.$q.when<boolean>(true);
        });
    }
    // Simplify a date for display
    formatDate(complexDate:string):string{
        return new Date(complexDate).toLocaleString();
    }
    // User made a timestamp selection - find the record index for a timestamp
    updateIndex() {
        for (var i = 0; i < this.allGpsLocationHistories.length; i++) {
            if (this.allGpsLocationHistories[i].timeSeen == this.itemTimeSeen) {
                this.firstDisplayedPoint = i;
                break;
            }
        }
    }
}
